import React, { Component } from 'react';
import { Document, Page } from 'react-pdf';
import styled from 'styled-components';
const PageWrapper = styled.div `
  margin-bottom: 20px;
`;
const Styles = styled.div `
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  background: ${(props) => props.theme.vLightGray};
  display: flex;
  justify-content: center;
  * > :first-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
  }
`;
const Loading = styled.div `
  padding-top: 50px;
`;
class PDF extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            numPages: null,
            width: 0,
        };
        this.wrapperRef = React.createRef();
        this.updateWidth = (width) => {
            this.setState({
                width: width - 60,
            });
        };
        this.onDocumentLoadSuccess = ({ numPages }) => {
            const { current } = this.wrapperRef;
            if (current) {
                this.setState({ numPages });
                this.updateWidth(current.clientWidth);
            }
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.file.url !== this.props.file.url) {
            return true;
        }
        if (nextState.numPages !== this.state.numPages) {
            return true;
        }
        return false;
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.file.url !== this.props.file.url) {
            this.setState({ numPages: null });
        }
    }
    render() {
        const { file, loadingDocumentText, loadingPageText } = this.props;
        const { numPages, width } = this.state;
        return (React.createElement(Styles, { ref: this.wrapperRef },
            React.createElement(Document, { loading: React.createElement(Loading, null, loadingDocumentText), onLoadSuccess: this.onDocumentLoadSuccess, file: file }, numPages &&
                [...Array(numPages)].map((_, i) => {
                    return (React.createElement(PageWrapper, { key: i },
                        React.createElement(Page, { width: width, pageNumber: i + 1, loading: React.createElement(Loading, null, loadingPageText) })));
                }))));
    }
}
export default PDF;
